import React, { useState }  from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useOvermind } from '../../../../overmind';

class TypeAndLastUpdated extends React.Component {

  render(){
    let fingerprint = new Date(parseInt(this.props.data.fingerprint));
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    let month = monthNames[fingerprint.getMonth()];
    let day = String(fingerprint.getDate()).padStart(2, '0');
    let year = fingerprint.getFullYear();
    let fingerprintOutput = month  + '\n'+ day  + ', ' + year;

    return (
      <Box>
        <Box>
          <Typography variant="h6" gutterBottom style={{display: 'inline-block'}}>
            {this.props.type} Type &nbsp;
          </Typography>
          <Typography variant="body1" gutterBottom style={{display: 'inline-block'}}>
            {this.props.name}
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6" gutterBottom style={{display: 'inline-block'}}>
            Last Updated &nbsp;
          </Typography>
          <Typography variant="body1" gutterBottom style={{display: 'inline-block'}}>
            {fingerprintOutput}
          </Typography>
        </Box>
      </Box>
    );
  }
}

export default function TypeCard(props){
  const { state } = useOvermind();

  let typeName;
  if(props.type === 'Tag'){
    typeName = state.docDonutChart.tagNames[props.data.type]
  }else if(props.type === 'Trigger'){
    typeName = state.docDonutChart.triggerNames[props.data.type]
  }else if(props.type === 'Variable'){
    typeName = state.docDonutChart.variableNames[props.data.type]
  }

  return(
    <TypeAndLastUpdated type={props.type} data={props.data} name={typeName}/>
  )
}
